export default __webpack_public_path__ + "static/media/icon-membership-points.01e96bd9.svg";